export enum IdType {
  Project = 'ProjectIds',
  Organization = 'OrgIds',
}
